import io from "socket.io-client";
import Const from "./Const";

const socket = io(Const.URL);

export default socket;
